export const maximumMessageLength = '40';
export const maximumSalutationLength = '10';
export const maximumRecipientLength = '30';

export const BASKET_SALUTATION_NAME = 'salutation';
export const BASKET_RECIPIENT_NAME = 'recipient';
export const BASKET_MESSAGE_LINE_ONE_NAME = 'messageLineOne';
export const BASKET_MESSAGE_LINE_TWO_NAME = 'messageLineTwo';
export const BASKET_MESSAGE_LINE_THREE_NAME = 'messageLineThree';
export const BASKET_MESSAGE_LINE_FOUR_NAME = 'messageLineFour';
export const BASKET_MESSAGE_LINE_FIVE_NAME = 'messageLineFive';
